import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? (process.env.REACT_APP_API_URL || 'https://api.prepstop.com')
  : '';

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export interface UserProfile {
  id: string | number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  organizationName?: string;
  partnerType?: string;
  phoneNumber?: string;
  address?: string;
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  profileImageUrl?: string;
  market?: string;
  coverageLevel?: string;
}

export interface UpdateProfileData {
  phoneNumber?: string;
  // Note: Community partners can only update phone number
  // Other fields (firstName, lastName, organizationName, address, city, zip) 
  // are read-only and must be updated by administrators
}

export const userProfileService = {
  // Get current user profile
  getProfile: async (): Promise<UserProfile> => {
    const response = await axiosInstance.get('/user');
    return response.data;
  },

  // Update user profile
  updateProfile: async (data: UpdateProfileData): Promise<{ success: boolean; message: string; user: UserProfile }> => {
    const response = await axiosInstance.put('/user/profile', data);
    return response.data;
  },
};

export default userProfileService;
